import "./css/CustomisedForm.css"
import { useEffect, useState } from "react"
import { AiOutlineStar, AiFillStar } from "react-icons/ai"
import axios from "axios"
import api from "../config/backend"
import { BiSolidCheckCircle } from "react-icons/bi"
import { Button } from "@mui/material"
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const CustomisedForm = ({ form, submitEnabled }) => {
    const [userInputs, setUserInputs] = useState(undefined)
    const [submitSuccess, setSubmitSuccess] = useState(false)
    const [isredirect, setIsRedirect] = useState(false)
    const [fieldErrors, setFieldErrors] = useState({});

    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const validatePhoneNumber = (phoneNumber) => {
        const phoneRegex = /^\d{6,15}$/;
        return phoneRegex.test(phoneNumber);
    };

    const handleFieldValidation = (fieldName, value) => {
        if (fieldName.toLowerCase() === "email") {
            const isValidEmail = value === '' || validateEmail(value);
            setFieldErrors((prevErrors) => ({ ...prevErrors, [fieldName.toLowerCase()]: !isValidEmail }));
        } else if (fieldName.toLowerCase() === "phone") {
            const isValidPhoneNumber = value === '' || validatePhoneNumber(value);
            setFieldErrors((prevErrors) => ({ ...prevErrors, [fieldName.toLowerCase()]: !isValidPhoneNumber }));
        }
    };

    const handleFieldBlur = (fieldName, value) => {
        handleFieldValidation(fieldName, value);
    };



    console.log(userInputs)
    console.log(form)
    const areRequiredFieldsFilled = () => {
        const requiredFields = form.inputs.filter(item => item.required);
       
        return requiredFields.every(field => {
            const value = userInputs[field.fieldname];
            return value !== undefined && value !== null && value !== "";
        });
    };
    
    const handleSubmit = async () => {
        const hasErrors = Object.values(fieldErrors).some((error) => error);

        const isFormNotEmpty = Object.values(userInputs).some((value) => value !== "");

        if (hasErrors && isFormNotEmpty) {
            toast.error("Please fix the errors before submitting.");
            return;
        }
    
        if (!areRequiredFieldsFilled()) {
            toast.info("Please fill in all required fields.");
            return;
        }
    

        const activefields = form.inputs
            .filter(item => item.active)
            .map(item => item.fieldname)

        const data = { hash: form.hash }

        for (let [key, value] of Object.entries(userInputs)) {
            if (activefields.includes(key)) {
                data[key.toLowerCase()] = value
            }
        }

        const response = await axios.post(`${api}/Form/submit`, data)

        if (response.data.success) {
            setSubmitSuccess(true)
        } else {
            console.log(response.data)
        }
    }

    useEffect(() => {
        if (form) {
            const inputs = {}
            form.inputs.forEach(item => {
                if (item.fieldtype === "input" || item.fieldtype === "textbox") {
                    inputs[item.fieldname] = ""
                }
                else if (item.fieldtype === "rating") {
                    inputs[item.fieldname] = undefined
                }
                else {
                    inputs[item.fieldname] = ""
                }
            })

            setUserInputs(inputs)
        }
    }, [form])

    useEffect(() => {
        if (submitSuccess && form.submitaction.action === "redirect") {
            setTimeout(() => {
                window.location.href = form.submitaction.actiondata
            }, 3000)
        }
    }, [submitSuccess])

    if (submitSuccess) {
        if (form && form.submitaction.action === "message") {
            return (
                <div className="_5lvi">
                    <div className="indentor-hey">
                        <BiSolidCheckCircle />
                        <span>{form.submitaction.actiondata}</span>
                    </div>
                </div>
            )
        }
        else if (form && form.submitaction.action === "redirect") {
            return (
                <div className="_5lvi">
                    <div>
                        Redirecting to ... {form.submitaction.actiondata}
                    </div>
                </div>
            )
        }
    }

    return (
        <>
            <div className={`app-component-customizable-form ${form.theme === "Light" ? "--themelight" : "--themedark"}`}>
                <div style={{ backgroundColor: "#1372a2" }} className="app-component-customizable-form__header">
                    <h2 style={{ color: "#ffffff" }}>{form.title}</h2>
                </div>
                <div className="app-component-customizable-form__body">
                    {userInputs ? form.inputs.map(item => {
                        if (item.active === false) {
                            return undefined
                        }
                        const isRequired = item.required === true;
                        if (item.fieldtype === "input") {
                            return (
                                <div className="app-component-customizable-form__field">
                                    <label style={{ color: "#5b626b" }} className="app-component-customizable-form__field--label">{item.data.label}
                                    {isRequired && <span style={{ color: 'red' }}>  *</span>}</label>
                                    <input
                                        className="app-component-customizable-form__field--input"
                                        placeholder={item.data.placeholder}
                                        value={userInputs[item.fieldname]}
                                        onChange={e => {
                                            setUserInputs(prev => {
                                                const copy = { ...prev };
                                                copy[item.fieldname] = e.target.value;
                                                return copy;
                                            });

                                        }}
                                        onBlur={() => handleFieldBlur(item.fieldname, userInputs[item.fieldname])}
                                    />
                                    {fieldErrors[item.fieldname.toLowerCase()] && (
                                        <span style={{ color: 'red' }}>{item.fieldname.toLowerCase()} is invalid</span>
                                    )}
                                </div>
                            )
                        }
                        else if (item.fieldtype === "rating") {
                            return (
                                <div className="app-component-customizable-form__field">
                                    <label className="app-component-customizable-form__field--label">{item.data.label}  {isRequired && <span style={{ color: 'red' }}>  *</span>}</label>
                                    <div className="app-component-customizable-form__rating">
                                        {Array(5).fill(undefined).map((i, index) => {
                                            return (
                                                <div
                                                    className="app-component-customizable-form__rating--star"
                                                    key={index}
                                                    onClick={() => setUserInputs(prev => {
                                                        const copy = { ...prev }
                                                        copy[item.fieldname] = index + 1
                                                        return copy
                                                    })}
                                                >
                                                    {index < userInputs[item.fieldname] ? <AiFillStar style={{ color: "#FFD700" }} /> : <AiOutlineStar />}
                                                </div>
                                            )
                                        })}
                                    </div>
                                </div>
                            )
                        }
                        else if (item.fieldtype === "textbox") {
                            return (
                                <div className="app-component-customizable-form__field">
                                    <label className="app-component-customizable-form__field--label">{item.data.label}  {isRequired && <span style={{ color: 'red' }}>  *</span>}</label>
                                    <textarea
                                        className="app-component-customizable-form__field--input"
                                        rows={6}
                                        value={userInputs[item.fieldname]}
                                        onChange={e => setUserInputs(prev => {
                                            const copy = { ...prev }
                                            copy[item.fieldname] = e.target.value
                                            return copy
                                        })}
                                    />
                                </div>
                            )
                        }
                        else if (item.fieldtype === "select") {
                            return (
                                <div className="app-component-customizable-form__field">
                                    <label className="app-component-customizable-form__field--label">{item.data.label}  {isRequired && <span style={{ color: 'red' }}>  *</span>}</label>
                                    <div className="app-component-customizable-form__radio">
                                        {item.data.options.map((option, index) => (
                                            <div className="app-component-customizable-form__radio--wrapper" key={index}>
                                                <input
                                                    type="radio"
                                                    id={`option-${item.fieldname}-${index}`}
                                                    name={`select-${item.fieldname}`}
                                                    value={option}
                                                    checked={userInputs[item.fieldname] === option}
                                                    onChange={() => setUserInputs(prev => {
                                                        const copy = { ...prev };
                                                        copy[item.fieldname] = option;
                                                        return copy;
                                                    })}
                                                />
                                                <label htmlFor={`option-${item.fieldname}-${index}`}>{option}</label>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            );
                        }
                        return (
                            <div className="flex-column">
                                Unknown fieldtype
                            </div>
                        )
                    }) : undefined}
                </div>
                <div className="app-component-customizable-form__footer">
                    <Button variant="contained" className="app-btn-contained app-btn-primary" onClick={() => submitEnabled ? handleSubmit() : console.log("Preview")}>{form.submit}</Button>
                </div>
            </div>
        </>
    )
}

export default CustomisedForm
